<template>
  <v-container fluid grid-list-md py1 class="se mb-8">
    <v-layout row wrap>
      <v-flex xs12>
        <data-table ref="seTable" @editRow="load" @auditRow="audit" />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.operativos.se.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators" @keyup.enter="submit()">
                  <v-layout row wrap>
                    <!-- Negocio -->
                    <v-flex xs12 md4 lg2>
                      <v-autocomplete
                        v-model.trim="$v.se.negocio.$model"
                        :search-input.sync="view.elem.select.negocio.search"
                        :label="$t('view.operativos.se.form.negocio.label')"
                        :error-messages="getFirstErrorDescription($v.se.negocio)"
                        :items="view.elem.select.negocio.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        hide-no-data
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        @input="view.elem.select.negocio.search = ''" />
                    </v-flex>

                    <!-- SE -->
                    <v-flex v-if="['PROP', 'OPTBLUE', 'PAYFAC'].includes(se.negocio)" md4 lg2>
                      <v-text-field
                        v-model.trim="$v.se.se.$model"
                        :label="$t('view.operativos.se.form.se.label')"
                        :error-messages="getFirstErrorDescription($v.se.se)"
                        maxlength="10"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^[0-9]*$/.test(event.key);" />
                    </v-flex>

                    <!-- Store ID -->
                    <v-flex v-if="['PAYFACSID'].includes(se.negocio)" md4 lg2>
                      <v-text-field
                        v-model.trim="$v.se.storeid.$model"
                        :label="$t('view.operativos.se.form.storeid.label')"
                        :error-messages="getFirstErrorDescription($v.se.storeid)"
                        maxlength="12"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^[0-9]*$/.test(event.key);" />
                    </v-flex>

                    <!-- Seller -->
                    <v-flex v-if="['OPTBLUE', 'PAYFAC', 'PAYFACSID'].includes(se.negocio)" md4 lg2>
                      <v-text-field
                        v-model.trim="$v.se.seller.$model"
                        :label="$t('view.operativos.se.form.seller.label')"
                        :error-messages="getFirstErrorDescription($v.se.seller)"
                        maxlength="30"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^[0-9A-Za-z]*$/.test(event.key);" />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <!-- Nombre -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.se.nombre.$model"
                        :label="$t('view.operativos.se.form.nombre.label')"
                        :error-messages="getFirstErrorDescription($v.se.nombre)"
                        maxlength="150"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Razon Social -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.se.razonsocial.$model"
                        :label="$t('view.operativos.se.form.razonsocial.label')"
                        :error-messages="getFirstErrorDescription($v.se.razonsocial)"
                        maxlength="150"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Cuit -->
                    <v-flex xs12 md4>
                      <v-text-field
                        :key="refreshkey"
                        v-model.trim="$v.se.cuit.$model"
                        v-mask="'##-########-#'"
                        :label="$t('view.operativos.se.form.cuit.label')"
                        :error-messages="getFirstErrorDescription($v.se.cuit)"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Dereccion -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.se.direccion.$model"
                        :label="$t('view.operativos.se.form.direccion.label')"
                        :error-messages="getFirstErrorDescription($v.se.direccion)"
                        maxlength="150"
                        :disabled="view.action.submit.busy || (se.geoRelevancia == 1 && $userPermission.hasPermission('ROLE_EDICION_CAMPOS_DOMICILIO_SE') == false)"
                        @change="clearLocalization" />
                    </v-flex>

                    <v-flex xs12 md4>
                      <v-layout row wrap>
                        <!-- Altura -->
                        <v-flex xs6>
                          <v-text-field
                            v-model.trim="$v.se.altura.$model"
                            :label="$t('view.operativos.se.form.altura.label')"
                            :error-messages="getFirstErrorDescription($v.se.altura)"
                            maxlength="5"
                            :disabled="view.action.submit.busy || (se.geoRelevancia == 1 && $userPermission.hasPermission('ROLE_EDICION_CAMPOS_DOMICILIO_SE') == false)"
                            @change="clearLocalization" />
                        </v-flex>

                        <!-- Codigo Postal -->
                        <v-flex xs6>
                          <v-text-field
                            v-model.trim="$v.se.codigopostal.$model"
                            :label="$t('view.operativos.se.form.codigopostal.label')"
                            :error-messages="getFirstErrorDescription($v.se.codigopostal)"
                            maxlength="10"
                            :disabled="view.action.submit.busy || (se.geoRelevancia == 1 && $userPermission.hasPermission('ROLE_EDICION_CAMPOS_DOMICILIO_SE') == false)"
                            onkeypress="return /^[0-9.0-9]*$/.test(event.key);"
                            @change="clearLocalization" />
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- Provincia -->
                    <v-flex xs12 md4>
                      <v-autocomplete
                        v-model.trim="$v.se.provincia.$model"
                        :search-input.sync="view.elem.select.provincia.search"
                        :label="$t('view.operativos.se.form.provincia.label')"
                        :error-messages="getFirstErrorDescription($v.se.provincia)"
                        :items="view.elem.select.provincia.filteredList"
                        :disabled="view.action.submit.busy || (se.geoRelevancia == 1 && $userPermission.hasPermission('ROLE_EDICION_CAMPOS_DOMICILIO_SE') == false)"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        hide-no-data
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        @input="view.elem.select.provincia.search = ''"
                        @change="
                          form.$state.loadSelectLocalidad();
                          clearLocalization();
                        " />
                    </v-flex>

                    <!-- Localidad -->
                    <v-flex xs12 md4>
                      <v-autocomplete
                        v-model.trim="$v.se.localidad.$model"
                        :search-input.sync="view.elem.select.localidad.search"
                        :label="$t('view.operativos.se.form.localidad.label')"
                        :error-messages="getFirstErrorDescription($v.se.localidad)"
                        :items="view.elem.select.localidad.filteredList"
                        :disabled="view.action.submit.busy || (se.geoRelevancia == 1 && $userPermission.hasPermission('ROLE_EDICION_CAMPOS_DOMICILIO_SE') == false)"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        hide-no-data
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        @input="view.elem.select.localidad.search = ''"
                        @change="clearLocalization" />
                    </v-flex>

                    <!-- Referencia -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.se.referencia.$model"
                        :label="$t('view.operativos.se.form.referencia.label')"
                        :error-messages="getFirstErrorDescription($v.se.referencia)"
                        maxlength="100"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Email -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model="$v.se.email.$model"
                        :label="$t('view.operativos.se.form.email.label')"
                        :error-messages="getFirstErrorDescription($v.se.email)"
                        maxlength="80"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Telefono -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.se.telefono.$model"
                        :label="$t('view.operativos.se.form.telefono.label')"
                        :error-messages="getFirstErrorDescription($v.se.telefono)"
                        maxlength="15"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^[0-9.0-9]*$/.test(event.key);" />
                    </v-flex>

                    <!-- Acuerdo -->
                    <v-flex xs12 md4>
                      <v-autocomplete
                        v-model.trim="$v.se.acuerdo.$model"
                        :search-input.sync="view.elem.select.acuerdo.search"
                        :label="$t('view.operativos.se.form.acuerdo.label')"
                        :error-messages="getFirstErrorDescription($v.se.acuerdo)"
                        :items="view.elem.select.acuerdo.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        hide-no-data
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        @input="view.elem.select.acuerdo.search = ''" />
                    </v-flex>

                    <!-- Subindustria -->
                    <v-flex xs12 md4>
                      <v-autocomplete
                        v-model.trim="$v.se.subindustria.$model"
                        :search-input.sync="view.elem.select.subindustria.search"
                        :label="$t('view.operativos.se.form.subindustria.label')"
                        :error-messages="getFirstErrorDescription($v.se.subindustria)"
                        :items="view.elem.select.subindustria.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        hide-no-data
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        @input="view.elem.select.subindustria.search = ''" />
                    </v-flex>

                    <!-- Partner -->
                    <v-flex xs12 md4>
                      <v-autocomplete
                        v-model.trim="$v.se.partner.$model"
                        :search-input.sync="view.elem.select.partner.search"
                        :label="$t('view.operativos.se.form.partner.label')"
                        :error-messages="getFirstErrorDescription($v.se.partner)"
                        :items="view.elem.select.partner.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        hide-no-data
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        @input="view.elem.select.partner.search = ''" />
                    </v-flex>

                    <!-- Latitud -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.se.latitud.$model"
                        :label="$t('view.operativos.se.form.latitud.label')"
                        :error-messages="getFirstErrorDescription($v.se.latitud)"
                        maxlength="20"
                        :disabled="view.action.submit.busy || (se.geoRelevancia == 1 && $userPermission.hasPermission('ROLE_EDICION_CAMPOS_DOMICILIO_SE') == false)"
                        onkeypress="return /^[0-9.0-9]*$/.test(event.key);" />
                    </v-flex>

                    <!-- Longitud -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.se.longitud.$model"
                        :label="$t('view.operativos.se.form.longitud.label')"
                        :error-messages="getFirstErrorDescription($v.se.longitud)"
                        maxlength="20"
                        :disabled="view.action.submit.busy || (se.geoRelevancia == 1 && $userPermission.hasPermission('ROLE_EDICION_CAMPOS_DOMICILIO_SE') == false)"
                        onkeypress="return /^[0-9.0-9]*$/.test(event.key);" />
                    </v-flex>

                    <!-- getRelevancia -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.number="$v.se.geoRelevancia.$model"
                        :label="$t('view.operativos.se.form.geoRelevancia.label')"
                        :error-messages="getFirstErrorDescription($v.se.geoRelevancia)"
                        :disabled="se.geoRelevancia == 1 && $userPermission.hasPermission('ROLE_EDICION_CAMPOS_DOMICILIO_SE') == false"
                        type="number"
                        step="0.01"
                        min="0"
                        max="1"
                        onkeypress="return /^[0-9,.]*$/.test(event.key);"
                        oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;" />
                    </v-flex>

                    <!-- Grupo Control -->
                    <v-flex md2 class="ps-md-7">
                      <label for="grupocontrol" class="v-label mt-3">{{ $t("view.operativos.se.form.grupocontrol.label") }}</label>
                      <v-switch v-model="se.grupocontrol" input-value="true" color="primary" :disabled="view.action.submit.busy" class="mt-1" />
                    </v-flex>

                    <!-- Estatus -->
                    <v-flex md2>
                      <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                      <v-switch v-model="se.status" input-value="true" color="primary" :disabled="view.action.submit.busy" class="mt-1" />
                    </v-flex>
                  </v-layout>
                </form>
              </v-card-text>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>
    </v-layout>

    <gallery ref="gallery" :se="se" @removePhoto="removePhoto" />

    <v-layout align-center column class="fab-container">
      <v-btn
        v-show="se.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
        id="btnaudit"
        fab
        small
        color="primary"
        class="btn_tippy"
        elevation="0"
        :title="$t('view.commons.audit')"
        :loading="view.action.submit.busy"
        @click="audit()">
        <v-icon small>storage</v-icon>
      </v-btn>

      <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
        <v-icon small>fa-eraser</v-icon>
      </v-btn>

      <v-btn
        v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
        id="btnsubmit"
        fab
        small
        color="primary"
        class="btn_tippy"
        elevation="0"
        :title="view.elem.button.submit.title.current"
        :loading="view.action.submit.busy"
        @click="submit()">
        <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
      </v-btn>
    </v-layout>

    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import seStates from "@/views/operativos/se/se-state"; /** *******************************/
import seAPI from "@/services/operativos/se"; /** *******************************/
import DataTable from "@/views/operativos/se/DataTable"; /** *******************************/
import Gallery from "@/views/operativos/se/Gallery"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required, requiredIf, minLength, email } from "vuelidate/lib/validators";
import { cuit, fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { submit } from "@/constants/buttons";
import { SE_NEGOCIO_SELECT } from "@/constants/operativos";
import tippy from "tippy.js";

const action = { submit: { busy: false } };

const select = {
  negocio: {
    completeList: SE_NEGOCIO_SELECT
    , filteredList: SE_NEGOCIO_SELECT
    , disabled: false
    , search: ""
  }
  , provincia: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
  , localidad: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
  , acuerdo: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
  , subindustria: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
  , partner: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
};

export default {
  name: "SeModule"
  , components: {
    DataTable
    , Gallery
    , Auditoria
  }
  , data() {
    return {
      se: undefined
      , refreshkey: 0
      , form: new Object()
      , view: {
        title: this.$t("view.operativos.se.title")
        , action
        , elem: {
          button: { submit }
          , select
          , showForm: true
        }
      }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new seStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.se);
        if (handleResponse(respuesta, this.$t("view.operativos.se.errors"))) {
          if (respuesta.data.results.se.provincia) await this.form.$state.loadSelectLocalidad(respuesta.data.results.se.provincia);
          this.form.$setState("editing", respuesta.data.results.se);
        }
      } catch (error) {
        console.log(error);
        handleResponse(error, this.$t("view.operativos.se.errors"));
      }
    }
    , async load(clave) {
      try {
        const response = await seAPI.get(clave);
        const { data: { results: { se } } } = response;
        if (se.provincia) await this.form.$state.loadSelectLocalidad(se.provincia);
        this.form.$setState("editing", se);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.se.clave, dataDescripcion = this.se.se) {
      this.$refs.auditModal.loadAudit(clave, "TSe", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
    , async clearLocalization() {
      this.se.longitud = "";
      this.se.latitud = "";
      this.se.geoRelevancia = null;
    }
    , removePhoto(photos) {
      this.se.photos = photos;
    }
  }
  , validations: {
    se: {
      negocio: { required }
      , se: {
        minLength: minLength(10)
        , required: requiredIf(function () {
          return ["PROP", "OPTBLUE", "PAYFAC"].includes(this.se.negocio);
        })
      }
      , storeid: {
        minLength: minLength(12)
        , required: requiredIf(function () {
          return ["PAYFACSID"].includes(this.se.negocio);
        })
      }
      , seller: {
        required: requiredIf(function () {
          return ["OPTBLUE", "PAYFAC", "PAYFACSID"].includes(this.se.negocio);
        })
      }
      , nombre: { fixMigImp: fixMigImp() }
      , razonsocial: { fixMigImp: fixMigImp() }
      , cuit: { cuit: cuit() }
      , direccion: { fixMigImp: fixMigImp() }
      , altura: { fixMigImp: fixMigImp() }
      , provincia: {}
      , localidad: {}
      , referencia: {}
      , codigopostal: {}
      , email: { email }
      , telefono: {}
      , acuerdo: {}
      , subindustria: {
        required: requiredIf(function () {
          return ["PROP", "OPTBLUE"].includes(this.se.negocio);
        })
      }
      , partner: {}
      , latitud: {}
      , longitud: {}
      , geoRelevancia: { required }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.se .fab-container {
  position: fixed;
  bottom: 90px;
  right: 20px;
  z-index: 1;
}
.se .fab-container .v-btn {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/se/Se.vue